import React from 'react';
import { IconButton } from '@material-ui/core';
import { Pencil, Trash } from 'tabler-icons-react';
import { useShifts } from './ShiftsContext.jsx';
import '../../styles/turnos.css';

function formatTime(timeStr) {
    if (!timeStr) return '--:--';
    const t = timeStr.includes('T') ? timeStr.split('T')[1] : timeStr;
    const [hh, mm] = t.split(':');
    const h = parseInt(hh, 10);
    const period = h < 12 ? 'AM' : 'PM';
    const h12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
    return `${h12}:${mm} ${period}`;
}

function Shift({ turn }) {
    const {
        setEditingTurn,
        setDialogEditTurn,
        setDialogDeleteTurn,
        setSelectedTurn,
        selectedTurn,
        getHorarios,
        selectedLine,
        setSchedules,
    } = useShifts();

    const isSelected = selectedTurn?.turno === turn.turno;

    const handleSelect = (e) => {
        e.preventDefault();
        setSelectedTurn(turn);
        getHorarios(selectedLine, turn.turno);
    };

    const handleEdit = (e) => {
        e.stopPropagation();
        setEditingTurn(turn);
        setDialogEditTurn(true);
    };

    const handleDelete = (e) => {
        e.stopPropagation();
        setSelectedTurn(turn);
        setSchedules([]);
        setDialogDeleteTurn(true);
    };

    return (
        <div
            className={`turnos-shift-item${isSelected ? ' turnos-shift-item--selected' : ''}`}
            onClick={handleSelect}
        >
            <div className="turnos-shift-item-row">
                <div>
                    <div className="turnos-shift-name">Turno {turn.turno}</div>
                    <div className="turnos-shift-time-label">Inicio</div>
                    <div className="turnos-shift-time-value">{formatTime(turn.horaInicio)}</div>
                </div>
                <div className="turnos-shift-actions">
                    <IconButton size="small" className="turnos-shift-edit-btn" onClick={handleEdit}>
                        <Pencil size={14} strokeWidth={1.75} />
                    </IconButton>
                    <IconButton size="small" className="turnos-shift-delete-btn" onClick={handleDelete}>
                        <Trash size={14} strokeWidth={1.75} />
                    </IconButton>
                </div>
            </div>
        </div>
    );
}

export default Shift;
